
const MapFilters = ({ filters, filterOptions, onFilterChange, onClearFilters }) => {
  return (
    <div className="card mb-4">
      <div className="card-header">
        <h5 className="card-title mb-0">Filters</h5>
      </div>
      <div className="card-body">
        <div className="row g-3">
          <div className="col-md-2">
            <label htmlFor="categoryFilter" className="form-label-table">Category</label>
            <select 
              id="categoryFilter"
              className="form-select"
              value={filters.category}
              onChange={(e) => onFilterChange('category', e.target.value)}
            >
              <option value="">All Categories</option>
              {filterOptions.categories.map((category, index) => (
                <option key={index} value={category}>{category}</option>
              ))}
            </select>
          </div>
          <div className="col-md-2">
            <label htmlFor="provinceFilter" className="form-label-table">Province</label>
            <select 
              id="provinceFilter"
              className="form-select"
              value={filters.province}
              onChange={(e) => onFilterChange('province', e.target.value)}
            >
              <option value="">All Provinces</option>
              {filterOptions.provinces.map((province, index) => (
                <option key={index} value={province}>{province}</option>
              ))}
            </select>
          </div>
          
          <div className="col-md-2">
            <label htmlFor="districtFilter" className="form-label-table">District</label>
            <select 
              id="districtFilter"
              className="form-select"
              value={filters.district}
              onChange={(e) => onFilterChange('district', e.target.value)}
            >
              <option value="">All Districts</option>
              {filterOptions.districts.map((district, index) => (
                <option key={index} value={district}>{district}</option>
              ))}
            </select>
          </div>
          
          <div className="col-md-2">
            <label htmlFor="tehsilFilter" className="form-label-table">Tehsil</label>
            <select 
              id="tehsilFilter"
              className="form-select"
              value={filters.tehsil}
              onChange={(e) => onFilterChange('tehsil', e.target.value)}
            >
              <option value="">All Tehsils</option>
              {filterOptions.tehsils.map((tehsil, index) => (
                <option key={index} value={tehsil}>{tehsil}</option>
              ))}
            </select>
          </div>
          
          <div className="col-md-2">
            <label htmlFor="campaignFilter" className="form-label-table">Campaign</label>
            <select 
              id="campaignFilter"
              className="form-select"
              value={filters.plantationCampaign}
              onChange={(e) => onFilterChange('plantationCampaign', e.target.value)}
            >
              <option value="">All Campaigns</option>
              {filterOptions.plantationCampaigns.map((campaign, index) => (
                <option key={index} value={campaign}>{campaign}</option>
              ))}
            </select>
          </div>
          
          <div className="col-md-2">
            <label htmlFor="typeFilter" className="form-label-table">Plantation Type</label>
            <select 
              id="typeFilter"
              className="form-select"
              value={filters.plantationType}
              onChange={(e) => onFilterChange('plantationType', e.target.value)}
            >
              <option value="">All Types</option>
              {filterOptions.plantationTypes.map((type, index) => (
                <option key={index} value={type}>{type}</option>
              ))}
            </select>
          </div>
          
          <div className="col-md-2">
            <label htmlFor="yearFilter" className="form-label-table">Year</label>
            <select 
              id="yearFilter"
              className="form-select"
              value={filters.yearOfPlantation}
              onChange={(e) => onFilterChange('yearOfPlantation', e.target.value)}
            >
              <option value="">All Years</option>
              {filterOptions.years.map((year, index) => (
                <option key={index} value={year}>{year}</option>
              ))}
            </select>
          </div>
          
          <div className="col-md-2">
            <label htmlFor="siteTypeFilter" className="form-label-table">Site Type</label>
            <select 
              id="siteTypeFilter"
              className="form-select"
              value={filters.siteType}
              onChange={(e) => onFilterChange('siteType', e.target.value)}
            >
              <option value="">All Site Types</option>
              {filterOptions.siteTypes.map((siteType, index) => (
                <option key={index} value={siteType}>{siteType}</option>
              ))}
            </select>
          </div>
          
          <div className="col-md-2 d-flex align-items-end">
            <button 
              className="btn btn-outline-secondary w-100"
              onClick={onClearFilters}
            >
              Clear Filters
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapFilters;